import { Logo } from "./Logo";
import { NAV } from "../data/content";
import { useSite } from "../context/SiteContext";

export const Footer = () => {
  const site = useSite();
  const { email, phone } = site.contact;
  return (
  <footer data-testid="site-footer" className="bg-ink text-sand">
    <div className="mx-auto max-w-7xl border-t border-sand/15 px-5 py-14 sm:px-8">
      <div className="grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-sand/70">Hotel management company in Bali since 2014 — operations, revenue, marketing and consulting for independent hotels and villas.</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-sand/60">Explore</p>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV.map((n) => <li key={n.href}><a href={`/${n.href}`} className="link-underline text-sand/85 hover:text-sand">{n.label}</a></li>)}
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-sand/60">Contact</p>
          <ul className="mt-4 space-y-2 text-sm text-sand/85">
            <li><a href={`mailto:${email}`} data-testid="footer-email">{email}</a></li>
            <li><a href={site.phoneHref} data-testid="footer-phone">{phone}</a></li>
            <li className="text-sand/70">{site.regions.join(" · ")}</li>
          </ul>
        </div>
      </div>
      <p className="mt-14 text-xs text-sand/60">© {new Date().getFullYear()} Bedsolving. All rights reserved.</p>
    </div>
  </footer>
  );
};
